module.exports = __webpack_public_path__ + "media/images/dividend/ic-gift-closed-50e8f8bb2d121e015aa35816226c9a23.svg";